<template>
  <dropdown
    :value="sort"
    :label="$t('wizard.sort')"
    :options="sortOptions"
    @select="onSortSelect"
  />
</template>

<script>
// @flow

import { mapActions, mapState } from 'vuex'
import { WIZARD_SORTING_VALUES } from '@chatchamp/chatchamp-types'

import { dispatchChatchampEvent, WIZARD_EVENTS } from '../../../../main/eventTracking'

import Dropdown from '../../Dropdown/Dropdown.vue'

export default {
  components: {
    Dropdown
  },
  computed: {
    ...mapState(['sort', 'recommendedProducts']),
    sortOptions () {
      return Object.keys(WIZARD_SORTING_VALUES)
        .filter((value) => {
          if (value.includes('rating')) return this.thereAreCustomerRatings
          return true
        })
        .map((value) => ({
          label: this.$t(`wizard.sorting.${value}`),
          value
        }))
    },
    thereAreCustomerRatings () {
      return this.recommendedProducts?.elements.some(p => !!p.customerRating)
    }
  },
  methods: {
    ...mapActions(['changeSort']),
    onSortSelect (value) {
      this.changeSort(value)
      dispatchChatchampEvent(WIZARD_EVENTS.ProductsSortedEvent, {
        customerId: this.$store.state.customerId,
        subscriberId: this.$store.state.subscriberId,
        wizardId: this.$store.state.wizard.id,
        sorting: value
      })
    }
  }
}
</script>
